<template>
  <div :class="postHeroClasses">
    <img class="image" :src="poster" @load="onLoadImage" />
    <div class="main">
      <div class="container">
        <div class="subtitle">还没有权限播放</div>
        <div class="title">{{ post.title }}</div>
        <div class="meta">{{ meta }}</div>
        <div class="description">{{ description }}</div>
        <div class="action">
          <router-link class="button primary green" :to="actionLinkTo"
            >查看相关系列</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'PostHero',

  /**
   * 属性
   */
  props: {
    post: Object,
  },

  /**
   * 数据
   */
  data() {
    return {
      loading: true,
    };
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      poster: 'post/player/poster',
    }),

    meta() {
      return `时长：${this.post.video.duration}`;
    },

    description() {
      const series = this.post.series;
      return `此视频属于 《${series.title}》系列，共 ${series.packCount} 集，
      全长 ${series.duration}，请先办理相关路线的通行证，然后就可以无限次观看这个视频了。`;
    },

    actionLinkTo() {
      return {
        name: 'seriesShow',
        params: {
          seriesId: this.post.series.id,
        },
      };
    },

    postHeroClasses() {
      return ['post-hero', { loading: this.loading }];
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    onLoadImage() {
      this.loading = false;
    },
  },

  /**
   * 使用组件
   */
  components: {},
});
</script>

<style scoped>
@import './styles/post-hero.css';
</style>
